import HairRemovalDetail from "@/pages/treatment/hair-removal/components/HairRemovalDetail";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function HairRemovalPage() {
  const data = getTreatmentPage("hair-removal");
  if (!data) return null;
  return <HairRemovalDetail data={data} />;
}